<section *ngIf="!vm.loading">
	<h1 class="o-grid__cell c-text c-text--heading c-text--xl u-osb-lg o-grid__cell--w-100">{{'PreVisit.Card_List.PreVisit_Insert_For_Person' | translate}}</h1>
	<div class="o-grid" *ngIf="vm.settings?.xRoadCareTakenCheckEnabled && vm.settings?.xRoadCareTakenCheckVisible && !vm.isValidatePatientStep2">
		<div class="o-grid__cell o-grid__cell--w-100 u-osb-sm">
			<p>{{'PreVisit.Insert_For_Person_List.Rahvastikuregister_Disclaimer' | translate}}</p>
			<p class="c-text--bold" *ngIf="vm.lastFetchDate">{{'PreVisit.Insert_For_Person_List.Rahvastikuregister_Last_Check' | translate}}: {{ vm.lastFetchDate | date:'YYYY-MM-dd' }}</p>
		</div>
	</div>
</section>
<section class="c-section u-no-pb">
	<div class="o-grid">
		<div class="o-grid__cell c-cell">
			<div class="c-card">
				<div class="c-content" id="{{vm.uid}}" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}">
					<div *ngIf="!vm.loading">
						<div *ngIf="!vm.isValidatePatientStep2 && vm.persons?.length">
							<div class="c-content c-content--border-bottom u-no-pt u-no-ph@md-and-up u-hidden@up-to-md">
								<div class="o-grid o-grid--wrap ">
									<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
										<p class="c-text c-text--gray">{{'PreVisit.Insert_For_Person_List.Source' | translate}}</p>
									</div>
									<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
										<p class="c-text c-text--gray">{{'PreVisit.Insert_For_Person_List.Id_Code' | translate}}</p>
									</div>
									<div class="o-grid__cell o-grid__cell--w-40 u-no-p">
										<p class="c-text c-text--gray">{{'PreVisit.Insert_For_Person_List.Name' | translate}}</p>
									</div>
									<div class="o-grid__cell o-grid__cell--w-20 c-text--right u-no-p"></div>
								</div>
							</div>
							<ul class="c-list">
							<ng-container *ngFor="let person of vm.persons ; let $index=index">
								<li *ngIf="person.statusInfo !== 'EMPTY'">
									<div class="c-content c-content--border-bottom u-no-ph@md-and-up">
										<div class="o-grid o-grid--wrap@up-to-md u-ost-sm@md-and-up">
											<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
												<p class="o-grid c-text c-text--sm@up-to-sm">
													<span class="u-hidden@md-and-up">{{ 'PreVisit.Insert_For_Person_List.Source' | translate }}: </span>
													<span class="o-grid__cell--right@up-to-md">{{ (person.source === 'RR86' ? 'PreVisit.Insert_For_Person_List.Rahvastikuregister' : 'PreVisit.Insert_For_Person_List.Manually_Added') | translate }}</span>
												</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
												<p class="o-grid c-text c-text--sm@up-to-sm">
													<span class="u-hidden@md-and-up">{{ 'PreVisit.Insert_For_Person_List.Id_Code' | translate }}: </span>
													<span class="o-grid__cell--right@up-to-md">{{ person.personalCode }}</span>
												</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-40@md-and-up u-no-p">
												<p class="o-grid c-text c-text--sm@up-to-sm">
													<span class="u-hidden@md-and-up">{{ 'PreVisit.Insert_For_Person_List.Name' | translate }}: </span>
													<span class="o-grid__cell--right@up-to-md">{{ person.firstname }} {{ person.lastname }}</span>
												</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
												<p class="o-grid c-text c-text--sm@up-to-sm">
													<span class="u-hidden@md-and-up">{{ 'PreVisit.Insert_For_Person_List.Action' | translate }}: </span>
													<span class="o-grid__cell--right">
														<a id="deleteButton{{person.id}}" (click)="deleteCareTaken(person)" *ngIf="person.source === 'MANUAL'" class="c-button c-button--link">
															{{'PreVisit.Insert_For_Person_List.Button_Delete' | translate}}
														</a>
														&nbsp;
														&nbsp;
														<a id="selectButton{{person.id}}" (click)="selectPerson(person)" class="c-button c-button--link">
															{{'PreVisit.Insert_For_Person_List.Button_Select' | translate}}
														</a>
													</span>
												</p>
											</div>
										</div>
									</div>
								</li>
							</ng-container>
							</ul>
							<div class="o-grid__cell o-grid__cell--w-100 c-text--right u-no-p">
								<button [routerLink]="['/pre-visit/insert-for-person']" id="addManuallyButton" class="c-button c-button--s1 u-osb-sm u-ost-sm">
									{{'PreVisit.Insert_For_Person_List.Button_Add_New' | translate}}
								</button>
								<span style="display:inline-block;vertical-align:top;margin-top:10px;margin-left:10px;">
									<item-info-popover 
										[text]="vm.manuallyAddedDisclaimer" 
										placement="left" 
										(click)="$event.preventDefault()" 
										class="u-osl-xs">
									</item-info-popover>
								</span>
							</div>
						</div>
						
						<div *ngIf="!vm.isValidatePatientStep2 && !vm.persons?.length">
							<div class="o-grid o-grid--center-h" >
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--center-h u-no-p">
									<img alt="No results" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/bg-empty.svg" style="max-width:350px;margin-top:40px;">
								</div>
							</div>
							<div class="o-grid o-grid--center-h">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--center-h u-no-p">
									<p class="c-text c-text--gray c-text--center c-text--lg u-ost-md">{{ 'Services.Title.NoContent' | translate }}</p>
								</div>
							</div>
							<br/>
							<div class="o-grid__cell o-grid__cell--w-100 c-text--right u-no-p">
								<button [routerLink]="['/pre-visit/insert-for-person']" id="addManuallyButton" class="c-button c-button--s1 u-osb-sm u-ost-sm">
									{{'PreVisit.Insert_For_Person_List.Button_Add_New' | translate}}
								</button>
								<span style="display:inline-block;vertical-align:top;margin-top:10px;margin-left:10px;">
									<item-info-popover 
										[text]="vm.manuallyAddedDisclaimer" 
										placement="left" 
										(click)="$event.preventDefault()" 
										class="u-osl-xs">
									</item-info-popover>
								</span>
							</div>
						</div>
						
						<div *ngIf="vm.isValidatePatientStep2" [ngClass]="{ 'c-form__group--error': vm.noConnectionDefined }">
							<label for="patientUserCheck" class="c-form__label u-osb-xs u-ost-md">
								{{'PreVisit.Insert_For_Person.Connection_With_Patient' | translate}}
							</label>
							<label class="c-radio">
								<input type="radio" name="nextOfKin" [(ngModel)]="vm.requesterRelationshipToPatient" value="NOK">
								<span id="nextOfKinLabel">{{'PreVisit.Insert_For_Person.Next_Of_Kin' | translate}}</span>
							</label>
							<label class="c-radio">
								<input type="radio" name="dependant" [(ngModel)]="vm.requesterRelationshipToPatient" value="DEPEN">
								<span id="dependantLabel">{{'PreVisit.Insert_For_Person.Dependant' | translate}}</span>
							</label>
							<label class="c-radio">
								<input type="radio" name="delegatee" [(ngModel)]="vm.requesterRelationshipToPatient" value="DELEGATEE">
								<span id="delegateeLabel">{{'PreVisit.Insert_For_Person.Care_Taker' | translate}}</span>
							</label>
							<label class="c-radio">
								<input type="radio" name="contact" [(ngModel)]="vm.requesterRelationshipToPatient" value="CONT">
								<span id="contactLabel">{{'PreVisit.Insert_For_Person.Other_Contact' | translate}}</span>
							</label>
							<br/>
							<div class="o-grid__cell o-grid__cell--w-100 c-text--right u-no-p">
								<button id="validatePatientIdentifierButton2" type="button" class="c-button c-button--s1 u-ost-md" 
									(click)="vm.validatePatientRelationship()">
									{{'PreVisit.Common.Forward' | translate}}
								</button>
							</div>
						</div>
						
					</div>
					<loader-overlay *ngIf="vm.loading"></loader-overlay>
				</div>
			</div>
		</div>
	</div>
</section>
